var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCyberIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.3,25l8.1,9.1l0.2,0.2v0.6v0.6c0,0.2-0.2,0.2-0.2,0.2l-0.8,0.8c-0.2,0.2-0.4,0.2-0.8,0.2s-0.2,0-0.4,0 c-0.2,0-0.2-0.2-0.4-0.2l-9.5-11.1c-0.2-0.2-0.4-0.6-0.4-0.8c0-0.2-0.2-0.6-0.2-0.8c0-0.2,0-0.6,0.2-0.8c0-0.2,0.2-0.6,0.4-0.8 l10.1-11.1l0.2-0.2h0.2c0,0,0.2,0,0.4,0s0.2,0.2,0.2,0.2l0.8,0.8l0.2,0.2v0.6c0,0,0,0.2,0,0.6s-0.2,0.2-0.2,0.2l-8.1,9.3 c-0.2,0.2-0.4,0.8-0.4,1C28.9,24.2,29.1,24.8,29.3,25z M18.6,22.6l-8.1-8.9l-0.2-0.4c0-0.2,0-0.2,0-0.6c0-0.4,0-0.2,0-0.6 c0-0.4,0.2,0,0.2,0l0.8-0.8c0-0.2,0.2-0.6,0.4-0.6h0.4l0.4,0.4l10.1,11.1c0.2,0.2,0.2,0.6,0.4,0.8c0,0.2,0.2,0.6,0.2,0.8 c0,0.2,0,0.6-0.2,0.8c0,0.2-0.2,0.6-0.4,0.8L12.4,36.3c0,0.2-0.2,0.2-0.2,0.2c-0.2,0-0.2,0-0.4,0c-0.2,0-0.2,0-0.4,0 c0,0,0,0-0.2-0.2l-0.8-0.4l-0.2-0.2c0-0.2,0-0.2,0-0.6c0-0.4,0-0.2,0-0.6c0-0.4,0.2-0.2,0.2-0.2l8.1-9.1c0.2-0.6,0.4-1,0.4-1.6 C19.2,23.4,18.8,23,18.6,22.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyberIcon);
export default __webpack_public_path__ + "static/media/cyber_icon.1dfb77af9de845afd8bf854334335261.svg";
export { ForwardRef as ReactComponent };